export default __webpack_public_path__ + "static/media/info12_Militante_representante_JDE.70a9a393.png";